import React from 'react';
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import {Button, Card, Col, Container, Form, Row} from "react-bootstrap";

class ManageAccount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            user: null
        };
    }

     componentDidMount() {
         const { navigate } = this.props;

         fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
             method: "POST",
             headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
         }).then(res => res.json())
             .then(
                 (result) => {
                     this.setState({
                         isLoaded: true,
                         user: result
                     });
                 },
                 (error) => {
                     navigate('/login');

                     this.setState({
                         isLoaded: false,
                         error,
                     });
                 }
             );
     }

    updateDetails(e) {
        e.preventDefault();

        const { navigate } = this.props;

        const body = {'first_name': e.target.first_name.value, 'last_name': e.target.last_name.value};

        fetch(process.env.REACT_APP_API_URL + '/my-account/' + this.state.user.id + '/update', {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
            (result) => {
                this.setState({
                    isLoaded: true,
                    user: result
                });

                navigate('/account');
            },
            (error) => {
                this.setState({
                    isLoaded: false,
                    error: error
                });
            }
        );
    }

    render() {
        const { isLoaded, user } = this.state;

        var content = null;

        if (isLoaded && user) {
            content = (<Row className="vh-100 d-flex justify-content-center align-items-center">
                <Col md={8} lg={6} xs={12}>
                    <div className="border border-3 border-primary"></div>
                    <Card className="shadow">
                        <Card.Body>
                            <div className="mb-3 mt-md-4">
                                <h2 className="fw-bold mb-2 text-uppercase ">ES</h2>
                                <p className=" mb-5">Your personal information is in save</p>
                                <div className="mb-3">
                                    <Form onSubmit={this.updateDetails.bind(this)}>
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label className="text-center">
                                                Email address
                                            </Form.Label>
                                            <Form.Control value={user.email} name="email" type="email" placeholder="Enter email" />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label className="text-center">
                                                First name
                                            </Form.Label>
                                            <Form.Control defaultValue={user.first_name} name="first_name" type="text" placeholder="Enter first name" />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label className="text-center">
                                                Last name
                                            </Form.Label>
                                            <Form.Control defaultValue={user.last_name} name="last_name" type="text" placeholder="Enter last name" />
                                        </Form.Group>

                                        <Form.Group
                                            className="mb-3"
                                            controlId="formBasicCheckbox"
                                        >
                                            <p className="small">
                                                <a className="text-primary" href="/account/change-password">
                                                    Change password
                                                </a>
                                            </p>
                                        </Form.Group>
                                        <div className="d-grid">
                                            <Button variant="primary" type="submit">
                                                Save changes
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>);
        } else {
            content = <h1>Wait a second...</h1>;
        }

        return <div>
            <Container>
                {content}
            </Container>
        </div>
    }
}

export default withRouter(ManageAccount);
